import { LimitSettings } from '../../../models/limits/limits.model';
import { useGet, useSend } from '../../useApi';

// GET / PUT /admin/limits/settings (each change audited).
const useLimitSettings = () => {
  const { data, loading, fetch, setData } = useGet<LimitSettings>('Failed to load limits');
  const { loading: saving, send } = useSend<LimitSettings>('Could not save the limits');
  return {
    settings: data,
    loading,
    saving,
    fetchSettings: () => fetch('api/v1/admin/limits/settings'),
    save: (values: Record<string, number>, reason: string, onDone?: () => void) =>
      send({ url: 'api/v1/admin/limits/settings', method: 'put', data: { values, reason } }, (body) => {
        setData(body);
        onDone?.();
      }),
  };
};

export default useLimitSettings;
